module.exports = __webpack_public_path__ + "static/media/Shape.534e876e.png";